import { render, staticRenderFns } from "./login-initial.html?vue&type=template&id=08065f96&"
import script from "./LoginInitial.vue?vue&type=script&lang=js&"
export * from "./LoginInitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports